import { useEffect, useState } from "react";
import { Loader2, Share2, Eye, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function AdminReferrals() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/referrals").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 animate-spin text-[#00E676]" /></div>;

  return (
    <div data-testid="admin-referrals">
      <h2 className="text-lg font-bold flex items-center gap-2 mb-1"><Share2 size={18} className="text-[#FFD700]" /> Suivi des parrainages</h2>
      <p className="text-sm text-[#697C6F] mb-4">
        On ne peut pas savoir si un membre a « posté » sur un réseau (limite des plateformes), mais on suit le nombre de <b className="text-[#39FF14]">clics réels</b> reçus sur son lien.
      </p>
      <div className="rounded-xl border border-[#00E676]/15 bg-[#131F17] overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wide text-[#697C6F] border-b border-[#00E676]/10">
              <th className="px-4 py-3">Membre</th>
              <th className="px-4 py-3 text-center">Clics sur son lien</th>
              <th className="px-4 py-3 text-center">Partage vérifié</th>
              <th className="px-4 py-3 text-center">Filleuls (validés / total)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={4} className="px-4 py-6 text-center text-[#697C6F]">Aucun membre.</td></tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id} className="border-b border-[#00E676]/5" data-testid={`ref-row-${r.id}`}>
                  <td className="px-4 py-3">
                    <div className="font-semibold">{r.name}</div>
                    <div className="text-xs text-[#697C6F]">{r.email}{r.code ? ` · ${r.code}` : ""}</div>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <span className="inline-flex items-center gap-1.5 tabular font-black text-[#39FF14]"><Eye size={14} /> {r.clicks}</span>
                  </td>
                  <td className="px-4 py-3 text-center">
                    {r.share_verified ? (
                      <span className="inline-flex items-center gap-1 text-[#39FF14] font-bold text-xs"><CheckCircle2 size={14} /> Oui</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-[#697C6F] text-xs"><XCircle size={14} /> Non</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-center tabular">
                    <span className="text-[#39FF14] font-black">{r.filleuls_valid}</span>
                    <span className="text-[#697C6F]"> / {r.filleuls_total}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
